import { currencyPrefix } from '../../utils/priceUtils';

/**
 * D152.1: the name of the selling-price field on a client-invoice line, in the grid header and the drawer.
 * "Selling price (US$)" / "(TT$)" / "(EUR)"; no currency, no brackets (D96.14: a currency is never invented).
 * The label comes from currencyPrefix (BUSINESS_RULES#quotation-screen-money-labels).
 */
export const sellingPriceLabel = (currency?: string | null): string => {
  const label = currencyPrefix(currency).trim();
  return label ? `Selling price (${label})` : 'Selling price';
};

/** D152.2: the name of the cost field on a client-invoice line ("Cost price (US$)" / "(TT$)"; no currency, no brackets). */
export const costPriceLabel = (currency?: string | null): string => {
  const label = currencyPrefix(currency).trim();
  return label ? `Cost price (${label})` : 'Cost price';
};

/** D171.8: the lines list's cost column, in the confirmed-order screen's form ("US$ Cost" / "TT$ Cost" / "EUR Cost"; none = "Cost"). */
export const costColumnLabel = (currency?: string | null): string => {
  const label = currencyPrefix(currency).trim();
  return label ? `${label} Cost` : 'Cost';
};
